/**
 * アラートダイアログ用定義
 */
import {
  /** アラートダイアログ用定義 */
  ALERT_DEF,
  /** アラートダイアログ用データ作成 */
  createAlertData,
} from '@/functions/common/alertFunc'

/** 全体的定義 */
const SITEMAP_OVERALL = {
  /** 表示中ページ */
  PAGES: 1,
  /** 1ページ表示件数 */
  PER_PAGE: 30,
  /** コンテンツリロード */
  CONTENT_RELOAD: '/dashboard/chatbot?view=sitemap&pages=',
}
/**機能名定義 */
const SITEMAP_ALERT_FUNCTION = {
  /** サイトマップメイン */
  SITEMAP_MAIN: 'sitemap-main',
  /** サイトマップテーブル */
  SITEMAP_TABLE: 'sitemap_table',
}
/** キーワード種別定義 */
const SITEMAP_ALERT_KEYWORD = {
  /** アラートダイアログ戻り値用キーワード(適用ロボ除外) */
  ALERT: 'sitemap-alert',
  /** アラートダイアログ戻り値用キーワード(適用ロボ除外) */
  TOAST: 'sitemap-toast',
  /** アラートダイアログ戻り値用キーワード(待機中サイトマップルート削除) */
  DEL_SITEMAP_WAIT: 'delete-sitemap-wait',
  /** アラートダイアログ戻り値用キーワード(サイトマップルート削除) */
  DEL_SITEMAP_ROOT: 'delete-sitemap-root',
  /** アラートダイアログ戻り値用キーワード(サイトマップノード削除) */
  DEL_SITEMAP_NODE: 'delete-sitemao-node',
  /** アラートダイアログ戻り値用キーワード(適用ロボ除外) */
  ROBO_UNAPPLY: 'unapply-robo',
}
/** 操作種別定義 */
const SITEMAP_ACTION_TYPE = {
  /** 更新操作(初回起動ロボ設定) */
  START_ROBO: 'start-robo',
  /** 更新操作(ロボ適用設定) */
  ROBO_APPLY: 'robo-apply',
  /** 更新操作(ロボ適用解除) */
  ROBO_UNAPPLY: 'robo-unapply',
  /** 更新操作(サイトマップノードパス変更) */
  EDIT_SITEMAP_NODE: 'edit-node',
  /** タグ一括登録 */
  TAG_ALL_ADD: 'tag-all-add',
  /** タグ一括削除 */
  TAG_ALL_DEL: 'tag-all-del',
}
/** ページ種別定義 */
const SITEMAP_PAGE_TYPE = {
  /** 求人ページ */
  RECRUIT_PAGE: 'recruit',
  /** カスタムページ */
  CUSTOM_PAGE: 'custom',
  /** ホームページ */
  HOME_PAGE: 'homepage',
}
/** タブインデックス定義 */
const SITEMAP_TAB_INDEX = {
  /** 求人ページ */
  RECRUIT_PAGE: 0,
  /** カスタムページ */
  CUSTOM_PAGE: 1,
  /** ホームページ */
  HOME_PAGE: 2,
}
/** コンテンツ種別 */
const SITEMAP_CONTENT_TYPE = {
  /** 求人ページ */
  RECRUIT_PAGE: 4,
  /** カスタムページ */
  CUSTOM_PAGE: 5,
  /** ホームページ用ダミー */
  HOME_PAGE: 0,
}
/**
 * Dispatchパス定義
 * ※Dispatchには使えないっぽいが、とりあえず残しておく
 */
const SITEMAP_DISPATCH = {
  /** サイトマップ用ロボリスト取得 */
  GET_SITEMAP_ROBO_LIST: 'sitemap/getSitemapRoboList',
  /** 求人ページおよびカスタムページ用タグリスト取得 */
  GET_RECRUIT_TAG_LIST: 'sitemap/getEmploymentTagList',
  /** ホームページ用タグ一覧取得 */
  GET_HOMEPAGE_TAG_LIST: 'sitemap/getHomePageTagList',
  /** 待機中サイトマップルートリスト取得 */
  GET_SITEMAP_WAIT_LIST: 'sitemap/getSitemapWaitList',
  /** 新規サイトマップルート登録 */
  REGIST_SITEMAP_WAIT: 'sitemap/registSitemapWait',
  /** 待機中サイトマップルート削除 */
  DELETE_SITEMAP_WAIT: 'sitemap/deleteSitemapWait',
  /** サイトマップルートリスト取得 */
  GET_SITEMAP_ROOT_LIST: 'sitemap/getSitemapRootList',
  /** サイトマップルートリスト取得 */
  ADD_SITEMAP_NODE: 'sitemap/addSitemapNode',
  /** サイトマップルート削除 */
  DELETE_SITEMAP_ROOT: 'sitemap/deleteSitemapRoot',
  /** サイトマップノード更新 */
  UPDATE_SITEMAP_NODE: 'sitemap/updateSitemapNode',
  /** サイトマップノード削除 */
  DELETE_SITEMAP_NODE: 'sitemap/deleteSitemapNode',
  /** 求人ページおよびカスタムページリスト取得 */
  GET_SITEMAP_EMPLOYMENT_LIST: 'sitemap/getSitemapEmploymentList',
  /** 求人ページリスト取得 */
  GET_SITEMAP_RECRUIT_LIST: 'sitemap/getSitemapRecruitList',
  /** カスタムページリスト取得 */
  GET_SITEMAP_CUSTOM_LIST: 'sitemap/getSitemapCustomList',
  /** 求人ページリスト取得 */
  GET_SITEMAP_RECRUIT_LIST_ALL: 'sitemap/getSitemapRecruitListAll',
  /** カスタムページリスト取得 */
  GET_SITEMAP_CUSTOM_LIST_ALL: 'sitemap/getSitemapCustomListAll',
  /** 求人ページおよびカスタムページ更新 */
  UPDATE_SITEMAP_RECRUIT: 'sitemap/updateSitemapEmployment',
  /** ロボ表示順取得 */
  GET_ROBO_ORDER: 'sitemap/getSitemapRoboOrder',
  /** ロボ表示順更新 */
  UPDATE_ROBO_ORDER: 'sitemap/updateSitemapRoboOrder',
  /** 選択中サイトマップルート設定 */
  SET_SELECT_SITEMAP: 'sitemap/setSelectSitemapRoot',
  /** サイトマップタグ追加 */
  ADD_SITEMAP_TAG: 'sitemap/addSitemapTag',
  /** サイトマップタグ削除 */
  DEL_SITEMAP_TAG: 'sitemap/deleteSitemapTag',
  /** サイトマップ全タグ編集 */
  EDIT_ALL_SITEMAP_TAG: 'sitemap/editAllSitemapTag',
  /** 表示中ページ番号設定 */
  SET_PAGE_NUMBER: 'sitemap/setNowPages',
  /** エラー表示リセット */
  RESET_ERROR: 'sitemap/resetError',
}

/**
 * エラーメッセージダイアログ表示
 * @param {String} functionName エラー発生機能名
 * @param {String} title エラーメッセージタイトル
 * @param {String} message エラーメッセージ
 */
function errorAlert(functionName, title, message) {
  const alertData = createAlertData(
    title,
    message,
    ALERT_DEF.MESSAGE_WARNING,
    ALERT_DEF.DIALOG_ALERT,
    functionName,
    SITEMAP_ALERT_KEYWORD.ALERT
  )
  return alertData
}

/**
 * 待機中サイトマップルート削除確認ダイアログ表示
 * @param {String} wait_url 待機中サイトマップルート
 */
function deleteSitemapWaitConfirm(wait_url) {
  const alertData = createAlertData(
    '待機中ルートサイトマップの削除',
    '「' + wait_url + '」\nを削除しますがよろしいですか？',
    ALERT_DEF.MESSAGE_DANGER,
    ALERT_DEF.DIALOG_CONFIRM,
    SITEMAP_ALERT_FUNCTION.SITEMAP_MAIN,
    SITEMAP_ALERT_KEYWORD.DEL_SITEMAP_WAIT
  )
  return alertData
}

/**
 * サイトマップルート削除確認ダイアログ表示
 * @param {String} root_url サイトマップルート
 */
function deleteSitemapRootConfirm(root_url) {
  const alertData = createAlertData(
    'ルートサイトマップの削除',
    '「' + root_url + '」\nを削除しますがよろしいですか？',
    ALERT_DEF.MESSAGE_DANGER,
    ALERT_DEF.DIALOG_CONFIRM,
    SITEMAP_ALERT_FUNCTION.SITEMAP_MAIN,
    SITEMAP_ALERT_KEYWORD.DEL_SITEMAP_ROOT
  )
  return alertData
}

/**
 * サイトマップノード削除確認ダイアログ表示
 * @param {String} node_url
 */
function deleteSitemapNodeConfirm(node_url) {
  // サイトマップノード削除確認ダイアログの表示
  const alertData = createAlertData(
    'パスの削除',
    '以下のパスをサイトマップから削除しますが、よろしいでしょうか？\n「' + node_url + '」',
    ALERT_DEF.MESSAGE_DANGER,
    ALERT_DEF.DIALOG_CONFIRM,
    SITEMAP_ALERT_FUNCTION.SITEMAP_TABLE,
    SITEMAP_ALERT_KEYWORD.DEL_SITEMAP_NODE
  )
  return alertData
}

/**
 * 適用ロボ除外確認ダイアログ表示
 * @param {String} unapplySiteName 対象サイト名
 * @param {String} unapplyRoboName 適用除外ロボ名
 */
function unapplyRoboConfirm(unapplySiteName, unapplyRoboName) {
  // ロボ適用除外モーダルオープン
  // 割り当て解除確認ダイアログの表示
  const alertData = createAlertData(
    'ロボの割り当て解除',
    '「' +
      unapplyRoboName +
      '」の割り当てを解除しますが、よろしいでしょうか？\n現在以下に割り当て中です。\n「' +
      unapplySiteName +
      '」',
    ALERT_DEF.MESSAGE_DANGER,
    ALERT_DEF.DIALOG_CONFIRM,
    SITEMAP_ALERT_FUNCTION.SITEMAP_TABLE,
    SITEMAP_ALERT_KEYWORD.ROBO_UNAPPLY
  )
  return alertData
}

export {
  SITEMAP_OVERALL,
  SITEMAP_PAGE_TYPE,
  SITEMAP_TAB_INDEX,
  SITEMAP_ALERT_FUNCTION,
  SITEMAP_ALERT_KEYWORD,
  SITEMAP_ACTION_TYPE,
  SITEMAP_DISPATCH,
  SITEMAP_CONTENT_TYPE,
  errorAlert,
  deleteSitemapRootConfirm,
  deleteSitemapWaitConfirm,
  deleteSitemapNodeConfirm,
  unapplyRoboConfirm,
}



// WEBPACK FOOTER //
// ./src/functions/users/sitemapFunc.js